import { Component } from '@angular/core';

import { AssignStaffComponent } from '../assign-staff/assign-staff.component';
import { ListPartnerStaffComponent } from '../list-partner-staff/list-partner-staff.component';
@Component({
    selector: 'app-partner-staff',
    templateUrl: './partner-staff.component.html',
    styleUrl: './partner-staff.component.css',
    imports: [AssignStaffComponent, ListPartnerStaffComponent]
})
export class PartnerStaffComponent {
  customerData: any;
  
  ngOnInit() {
    this.customerData = history.state.customerData;
  }
}
